/**
 * Get the progress bar ID from session storage or return default value
 * @returns {string} The progress bar ID
 */
export function getProgressBarId(){
  return sessionStorage.getItem('progress-bar-id') || 'sitewide';
}

/**
 * ProgressBar Web Component
 * @class ProgressBar
 */
class ProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    window.addEventListener('DOMContentLoaded', this.render.bind(this));
    document.addEventListener('cartItems:mutated', this.render.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('DOMContentLoaded', this.render.bind(this));
    document.removeEventListener('cartItems:mutated', this.render.bind(this));
  }

  render()
  {
    const id = getProgressBarId();
    const template = document.querySelector(`script[data-type="progress-bar"][data-id="${id}"]`);

    console.log('Rendering progress bar with id:', id);

    if (template) {
      this.innerHTML = template.innerHTML;
    }else{
      this.innerHTML = '';
      console.warn(`ProgressBar not found: [${id}]`);
    }
  }
}

if (!customElements.get("progress-bar")) {
  customElements.define("progress-bar", ProgressBar);
}